import initTabelaGenerica from '../mixins/initTabelaGenerica'
import { URLS } from '../constants/urls'
import { Grid, html as htmlGrid } from 'gridjs'

export default {
	props: ['clienteId'],
	mixins: [initTabelaGenerica],
	data() {
		return {
			tabelaRealocacao: null,
			columns: [
				{
					id: 'emissor',
					name: 'Nome do emissor',
					width: '220px',
					formatter: (cell, row) => {
						return row.percentual_disponivel === '—'
							? htmlGrid(
									`<span>${cell} <span style="font-size:11px;color:#888">(Não definido)</span></span>`
							  )
							: cell
					},
				},
				{
					id: 'percentual_disponivel',
					name: '% Disponível',
					width: '150px',
					sort: {
						compare: (a, b) => {
							if (a === '—' && b !== '—') return 1
							if (b === '—' && a !== '—') return -1
							if (a === '—' && b === '—') return 0
							return b - a
						},
					},
					formatter: (cell, row) => {
						return cell === '—'
							? 'Não definido'
							: typeof cell === 'number'
							? `${cell.toFixed(2)}%`
							: cell
					},
				},
				{
					id: 'valor_disponivel',
					name: 'Valor Disponível para Alocação',
					width: '220px',
					sort: {
						compare: (a, b) => {
							if (a === '—' && b !== '—') return 1
							if (b === '—' && a !== '—') return -1
							if (a === '—' && b === '—') return 0
							return b - a
						},
					},
					formatter: (cell, row) => {
						if (cell === '—' || cell === '-') return 'Não definido'

						const valor =
							typeof cell === 'number'
								? cell.toLocaleString('pt-br', {
										style: 'currency',
										currency: 'BRL',
								  })
								: cell

						if (typeof cell === 'number' && cell > 0) {
							return htmlGrid(
								`<span style="color: #18b25d; font-weight: bold;">${valor}</span>`
							)
						}
						if (cell < 0) {
							return htmlGrid(`<span style="color:red">${valor}</span>`)
						}
						return valor
					},
				},
			],
			data: [],
		}
	},
	methods: {
		iniciarTabela() {
			this.tabelaRealocacao = this.iniciarTabelaGenerica(
				this.columns,
				`${URLS.cliente_realocacao}?cliente_id=${this.clienteId}`,
				(response) => {
					const data = response?.data || []

					return this.formateDataTabelaRelacaoCliente(data)
				},
				(response) => response?.data?.length || 0,
				{
					pagination: {
						enabled: false, // <-- aqui desativa
						limit: 9999, // opcional: aumenta o limite para garantir todos os itens
						summary: false,
					},
				}
			)
			this.tabelaRealocacao.render(this.$refs.tableRealocacao)
		},

		formateDataTabelaRelacaoCliente(data = []) {
			return data?.sort((a, b) => b.valor_disponivel - a.valor_disponivel)
		},
	},
	mounted() {
		this.iniciarTabela()
	},
	template: `
        <div>
            <div ref="tableRealocacao"></div>
        </div>
    `,
}
